import script from "./RacViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RacViewPage.vue?vue&type=script&setup=true&lang=js"

import "./RacViewPage.vue?vue&type=style&index=0&id=17906d4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17906d4a"]])

export default __exports__